module.exports = __webpack_public_path__ + "img/menu_call_bg.848e2b19.svg";